/* eslint-disable comma-dangle */

export default {
  address: ['jk', 'jk-problem-message', 'map', 'user-input', 'building-address', 'underground', 'jk-message'],
  'about-object': [
    'housing-type',
    'rooms-count',
    'urban-total-area',
    'floor',
    'all-rooms-area',
    'living-area',
    'kitchen-area',
    'layout-photo',
    'visual-divider',
    'loggias-count',
    'balconies-count',
    'window-view-type',
    'visual-divider',
    'separate-wcs-count',
    'combined-wcs-count',
    'visual-divider',
    'decoration',
  ],
  'about-building': [
    'builder-name',
    'deadline',
    'new-building-material-type',
    'passenger-lifts',
    'cargo-lifts',
    'underground-parking',
  ],
  'price-and-deal-terms': ['price', 'new-building-sale-type', 'project-declaration-url', 'agent-bonus'],
};
